<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13igUsF/tc-custom/9781504082419.jpg?1705261436756" alt="This image is the cover for the book Ghostwriter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostwriter
      </h1>
      <p class="bookDescription body article font2">
        <b>A brand-new thriller by the bestselling author of <i>Girl in Bed Three</i>. A writer helps a victim of abuse tell her tale and finds herself becoming part of the story . . .</b><br/><br/> Single mother Polly has been struggling since work started to dry up, so she is hugely relieved when her sister contacts her about a potential ghostwriting job. And the woman who wants to hire Polly has a hell of a tale to tell. Sylvie was once trapped in a criminal underworld by her boyfriend who has since been jailed. She wants to share her story to help other women escape their abusive relationships . . . what could possibly go wrong?<br/><br/> Yet when Sylvie’s ex is paroled and she lets him back into her life, Polly wonders if the project is a mistake.<br/><br/> With more at stake than just a book, can Polly get out of a very dangerous situation with her life intact?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Sheridan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0501c978